// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'
import { util, validUtil, cookieUtil, sessionUtil } from '@/utils/utils.js'
import '@/public/css/zzStyle.css'
// import '@/public/js/easy-player-element.min.js'
import store from './store'
import ElementUI from 'element-ui'
import VueBus from 'vue-bus'
import 'element-ui/lib/theme-chalk/index.css';
// import VueVideoPlayer from 'vue-video-player';

// import 'videonpm.js/dist/video-js.css' //样式

// import 'vue-video-player/src/custom-theme.css' //样式

// import 'videojs-flash'

// Vue.use(VueVideoPlayer)

Vue.use(VueBus)
Vue.use(ElementUI)
    // Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.util = util
Vue.prototype.validUtil = validUtil
Vue.prototype.cookieUtil = cookieUtil
Vue.prototype.sessionUtil = sessionUtil


Vue.component('remote-script', {
    render: function(createElement) {
        var self = this;
        return createElement('script', {
            attrs: {
                type: 'text/javascript',
                src: this.src
            },
            on: {
                load: function(event) {
                    self.$emit('load', event);
                    //console.info("remote-script=========load===========");
                },
                error: function(event) {
                    self.$emit('error', event);
                    //console.info("remote-script=========error===========");
                },
                readystatechange: function(event) {
                    if (this.readyState == 'complete') {
                        self.$emit('load', event);
                    }
                    //console.info("remote-script=========readystatechange===========");
                }
            }
        });
    },
    props: {
        src: {
            type: String,
            required: true
        }
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    created() {
        this.util.init(this)
        // var _this=this
        // this.util.restGet('/api_v1/token', { userId: '09001', password: '123', loginType: 0 }, function(res) {
        //         // console.info("============模拟登陆方便测试===========");
        //         console.info(res);
        //         //console.info(cookieUtil);
        //         cookieUtil.clear('LoginOut');
        //         cookieUtil.setSession(res);
        //         var session = cookieUtil.getSession().data.user;
        //         _this.$store.state.userName = session.userName;
        //         _this.$store.state.userUid = session.id;
        //         _this.$store.state.userId = session.userId;
        //         _this.$store.state.companyUid = session.company;
        //         _this.$router.push({ path: '/page' });
        //         // _this.testGet();
        //     });
    },
    methods: {
        //   testGet() {

        //     this.util.restGet('/api_v1/token', { companyUid: this.sessionUtil.getCompanyUid(), start: 0, pageSize: 50 }, function(res) {
        //         console.info("============测试restful请求，token自动装填===========");
        //         console.info(res);
        //         this.cookieUtil.setSession(res)
        //     });
        // },
    }
})


// WEBPACK FOOTER //
// ./src/main.js